import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import insertScript from '../../../assets/scripts/utilities/insert-script.js'

class MicrioEmbedComponent extends Component {
  init() {
    window.addEventListener('init-after-load', this.initAfterLoad())
  }

  async initAfterLoad() {
    await insertScript('micrio-script', 'https://b.micr.io/micrio-4.3.min.js')

    this.indexMicrio = document.createElement('micr-io')
    this.indexMicrio.setAttribute('id', 'PdkQD')

    this.chaptersMicrio = document.createElement('micr-io')
    this.chaptersMicrio.setAttribute('id', 'yjkVk')

    this.themesMicrio = document.createElement('micr-io')
    this.themesMicrio.setAttribute('id', 'KdDGn')

    this.element.appendChild(this.indexMicrio)
    this.element.appendChild(this.chaptersMicrio)
    this.element.appendChild(this.themesMicrio)
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'micrio-embed', MicrioEmbedComponent))
